import { formatRupiah, formatDate } from "@/lib/format";
import StatusBadge from "@/components/StatusBadge";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/6e0fc21a-cb80-4712-b8a2-ad8db5b9866b/images/07cdcddce393b83511848cc8fe9a75a89a1af59cc01f06087a16701966566444.png";

// type: "invoice" | "quotation"
export const DocumentPaper = ({ doc, settings, type = "invoice" }) => {
  const title = type === "invoice" ? "INVOICE" : "PENAWARAN";
  const dateLabel = type === "invoice" ? "Tanggal Invoice" : "Tanggal Penawaran";
  const secondLabel = type === "invoice" ? "Jatuh Tempo" : "Berlaku Hingga";
  const secondValue = type === "invoice" ? doc.due_date : doc.valid_until;

  return (
    <div className="print-area mx-auto w-full max-w-3xl rounded-xl border border-border bg-white p-8 text-slate-900 shadow-sm sm:p-10">
      {/* Header */}
      <div className="flex flex-wrap items-start justify-between gap-4 border-b border-slate-200 pb-6">
        <div className="flex items-center gap-3">
          <img src={settings?.logo || LOGO} alt="logo" className="h-12 w-12 rounded-lg object-cover" />
          <div>
            <h2 className="font-heading text-lg font-extrabold tracking-tight">{settings?.business_name || "BukuKas Pro"}</h2>
            {settings?.address && <p className="max-w-xs text-xs text-slate-500">{settings.address}</p>}
            {settings?.whatsapp && <p className="text-xs text-slate-500">{settings.whatsapp}</p>}
          </div>
        </div>
        <div className="text-right">
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-blue-600">{title}</h1>
          <p className="mt-1 font-mono text-sm text-slate-500">{doc.number}</p>
          <div className="mt-2 flex justify-end"><StatusBadge status={doc.status} /></div>
        </div>
      </div>

      {/* Meta */}
      <div className="mt-6 flex flex-wrap justify-between gap-6">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Ditagihkan Kepada</p>
          <p className="mt-1 font-semibold">{doc.customer_name}</p>
          {doc.customer_whatsapp && <p className="text-sm text-slate-500">{doc.customer_whatsapp}</p>}
        </div>
        <div className="text-right text-sm">
          <div className="flex justify-end gap-6"><span className="text-slate-400">{dateLabel}</span><span className="font-medium">{formatDate(doc.date)}</span></div>
          {secondValue && <div className="mt-1 flex justify-end gap-6"><span className="text-slate-400">{secondLabel}</span><span className="font-medium">{formatDate(secondValue)}</span></div>}
        </div>
      </div>

      {/* Items */}
      <table className="mt-8 w-full text-sm">
        <thead>
          <tr className="border-b-2 border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
            <th className="pb-2">Deskripsi</th>
            <th className="pb-2 text-center">Qty</th>
            <th className="pb-2 text-right">Harga</th>
            <th className="pb-2 text-right">Jumlah</th>
          </tr>
        </thead>
        <tbody>
          {doc.items?.map((it, i) => (
            <tr key={i} className="border-b border-slate-100">
              <td className="py-3 font-medium">{it.name}</td>
              <td className="py-3 text-center">{it.qty}</td>
              <td className="py-3 text-right">{formatRupiah(it.price)}</td>
              <td className="py-3 text-right">{formatRupiah(it.qty * it.price)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div className="mt-6 flex justify-end">
        <div className="w-full max-w-xs space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-slate-500">Subtotal</span><span>{formatRupiah(doc.subtotal)}</span></div>
          {doc.discount_amount > 0 && <div className="flex justify-between"><span className="text-slate-500">Diskon</span><span>- {formatRupiah(doc.discount_amount)}</span></div>}
          {doc.tax_percent > 0 && <div className="flex justify-between"><span className="text-slate-500">PPN ({doc.tax_percent}%)</span><span>{formatRupiah(doc.tax_amount)}</span></div>}
          <div className="flex justify-between border-t-2 border-slate-200 pt-2 text-base font-bold">
            <span>Grand Total</span><span className="text-blue-600">{formatRupiah(doc.grand_total)}</span>
          </div>
        </div>
      </div>

      {doc.notes && (
        <div className="mt-8 border-t border-slate-200 pt-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Catatan</p>
          <p className="mt-1 text-sm text-slate-600">{doc.notes}</p>
        </div>
      )}
      <p className="mt-8 text-center text-xs text-slate-400">Dokumen ini dibuat secara elektronik oleh {settings?.business_name || "BukuKas Pro"}.</p>
    </div>
  );
};

export default DocumentPaper;
